import { Component, Input, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { CommonService, UserInfoService, CartService, UtilService, ProductCouponService, CouponListService, ProductUtilService, ShopCouponRefresh } from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';

@Component({
    selector: 'coupon-list-al-v1',
    templateUrl: './coupon-list-al-v1.component.html',
})
export class CouponListALV1Component implements OnInit, AfterViewInit {
    @Input() couponListData:any = {
        product: {},
        coupons: []
    };
    @Input() configObj:any = {};

    //public clippedLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CLD'];
    public clippedLabel = 'Clipped';

    public currentEnv = '';
    private config = EnviormentConfig;

    public offerCounter = 0;
    public offersClipped = 0;
    public offersCompleted = 0;
    public isBogoProduct = false;
    private imagePath = '';
    public isSnsOneTime = false;
    public disableNDC: boolean;
    public isLoading = true;
    couponFocusIndex = 0;
    @ViewChildren('couponContainer') couponContainer: QueryList<ElementRef>

    constructor(
        private _productCouponService: ProductCouponService,
        private cartService: CartService,
        private _couponListService: CouponListService,
        private _userInfoService: UserInfoService,
        private _commonService: CommonService,
        private _utilService: UtilService,
        private _productUtilService: ProductUtilService,
        private _elementRef: ElementRef

    ) {
        if(window?.['AB']?.['userInfo']&&!this._userInfoService.getUserSession()){
            this._userInfoService.initUserSession();
        }
        // Product cards on DNF page do NOT go to PDP page
        // this.imagePath = window['AB']['dMTProductCard'];
        this.imagePath = '';

        // 7.16.22 - Should have been cleaned in AEM , hard coding for nowto enable NDC
        // this.disableNDC = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].featureToggleConfig && window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableNDC ? true : false;
        this.disableNDC = false;

        this.currentEnv = this._commonService.getCurrentEnviorment();
    }

    public ngAfterViewInit() {
        this.couponContainer.changes.subscribe(() => {
            this.setFocus();
        });
    }

    public ngOnInit() {
        // Check for data-configObj for sns one time
        const dataConfigObj = this._elementRef.nativeElement.getAttribute('data-configObj');
        if (dataConfigObj){
            this.configObj = JSON.parse(dataConfigObj);
        }
        this.isBogoProduct = this.couponListData['product'] &&
        this._commonService.isProductPromoActive(this.couponListData['product']) && this.couponListData['product'].promoType
            ? this.couponListData['product'].promoType === 'M' || this.couponListData['product'].promoType === 'B'
            : false;

        if (this.configObj.programType === '1P_SNS' || this.configObj.appName === '1P_OA'){
            this.setSnsOneTimeData();
        }else{
            this.initializeCouponListData();
        }

        this._commonService.currentCartObj.subscribe(objCart => {
            if (objCart && this.couponListData['product']) {
                this.cartService.processOfferComplete(objCart, this.couponListData.coupons, this.couponListData.product);
                this.cartService.processBOGOComplete(objCart, this.couponListData.product);
                this.offersCompleted = this._couponListService.getTotalOffersCompleted(this.couponListData.coupons, this.couponListData.product);
            }
        });

        this._commonService.shopCouponRefreshSource.subscribe((couponRefresh: ShopCouponRefresh) => {
            if (couponRefresh && typeof couponRefresh === 'object' && 'id' in couponRefresh && 'deleted' in couponRefresh && 'status' in couponRefresh) {
                this.setOfferClippedCouponsCounter();
            }
        });

    }

    private setOfferClippedCouponsCounter() {
        this.offersClipped = (this.offerCounter > 0) ? this._productCouponService.getOffersClipped(this.couponListData['coupons']) : 0;
        if (this.isBogoProduct) {
            this.offersClipped += 1;
        }
    }

    private initializeCouponListData() {
        this.offerCounter = (this.couponListData['coupons']) ? this.couponListData['coupons'].length : 0;
        this.setOfferClippedCouponsCounter();

        if (this.isBogoProduct) {
            this.offerCounter += 1;
        }
    }


    public getImageUrl(id, viewport?: string): string {
        if (viewport) {
            return this.imagePath.replace('${product.id}', id).replace('${viewport}', viewport);
        } else {
            //return window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + id;
            return this.config[this.currentEnv].nimbusConfig['coupon.image.base.url'] + id;
        }
    };

    public clipCoupon(coupon) {

        if (this._isRegistered()) {
            const storeId = this._userInfoService.getShopStoreId();
            if (window && window['digitalData']) {
                window['digitalData'].coupon = {
                    carouselSection: 'offer-drawer'
                }
            }
            const analyticsData = {
                nativeElement: this._elementRef.nativeElement
            };
            this._productCouponService.clipCoupon(coupon, storeId, this.configObj, analyticsData).subscribe(response => {

                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {

                    this.couponFocusIndex = this.couponListData.coupons.findIndex(couponListCoupon => couponListCoupon.offerId == coupon.offerId);

                    this.setOfferClippedCouponsCounter();

                    this.offersCompleted = this._couponListService.getTotalOffersCompleted(this.couponListData.coupons, this.couponListData.product);
                }
            })
        } else {
            if (this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd') {
                const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
                window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
            } else {
                window['rightDrawerComp'].closeDrawer();
                window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
            }
        }
    };

    public setFocus() {
        if (this.couponContainer.length > 0) {
            const containerArray = this.couponContainer.toArray();
            if (containerArray[this.couponFocusIndex].nativeElement.querySelector('.coupon-list-clipped-add-more-text')) {
                containerArray[this.couponFocusIndex].nativeElement.querySelector('.coupon-list-clipped-add-more-text').focus();
            }

            if (containerArray[this.couponFocusIndex].nativeElement.querySelector('.coupon-list-offer-complete-text')) {
                containerArray[this.couponFocusIndex].nativeElement.querySelector('.coupon-list-offer-complete-text').focus();
            }
        }
    }

    public openDetailsDrawer(drawer, coupon?: any) {

        let objDrawerData = {};
        if (drawer === 'offer-detail') {
            objDrawerData = {
                type: drawer,
                coupon: coupon,
                product: this.couponListData.product,
                triggeredElement: 'coupon-list'
            };
            this._updateAnalyticsLinkClick('offer-drawer-j4u-multiple');
        } else if (drawer === 'bogo-detail') {
            objDrawerData = {
                type: drawer,
                product: this.couponListData.product,
                triggeredElement: 'coupon-list'
            };
            this._updateAnalyticsLinkClick('offer-drawer-bogo-multiple');
        }

        this._commonService.rightDrawerSource.next(objDrawerData);

    }

    public dispatchOneTimeEvent(coupon) : void{
        const isOA = this.configObj?.appName === '1P_OA'
        const eventName = isOA ? 'productCardComponentUpdate' : "snsOneTime";
        this._commonService.dispatchCustomOneTimeEvent(eventName, 'singleCoupon', { coupons: coupon });
    }

    public setSnsOneTimeData(){
        this.couponListData = {
            product: {},
            coupons: []
        };
        this.isSnsOneTime = true;
        const dataProduct = this._elementRef.nativeElement.getAttribute('data-product');
        if(dataProduct){
            this.couponListData.product = JSON.parse(dataProduct);    
        }
        this._couponListService.getOffersByUpc(this.couponListData.product.upc).subscribe((response) => {
            let i = 0;
            for(const key in response[this.couponListData.product?.upc].offers){
                this.couponListData['coupons'].push(response[this.couponListData.product.upc]?.offers[key]);
                this.couponListData['coupons'][i].offerComplete = false;
                i++;
            }
            this.initializeCouponListData();
            this.isLoading = false;
        }, (error) => {
            this.couponListData['coupons'] = [];
            this.isLoading = false;
        });
    }

    /**
    * Check if user is registered.
    */
    private _isRegistered(): boolean {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }

    private _updateAnalyticsLinkClick(offerType): void {
        let multipleText = '';
        if (this.offersClipped === 0) {
            multipleText = this.offerCounter + ' Coupons Available';
            window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
        } else if (this.offersClipped > 0) {
            multipleText = this.offersClipped + ' of ' + this.offerCounter + ' Coupons Clipped';
            window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
        } else {
            window['AB']['DATALAYER'].setLinkClickEvents(offerType);
        }
    }

    /**
     * Returns the appropriate singular or plural text for coupon count
     */
    public getCouponText(): string {
        return this.offerCounter === 1 ? 'Coupon' : 'Coupons';
    }
}
